export const generateOrderID = () => {
  const ts = Date.now().toString(36).toUpperCase();
  const rand = Math.floor(Math.random() * 100000)
    .toString()
    .padStart(5, "0");
  return `PC-${ts}-${rand}`;
};
